// extracted by mini-css-extract-plugin
export default {"menubar":"styles_menubar__Q0SCA","firstMenu":"styles_firstMenu__HKmxq","firstMenuIcon":"styles_firstMenuIcon__h2EzF","active":"styles_active__+nt92"};